import { selectableLeftAccentCardProps, surfaceRankBadgeProps } from "@canucci/base-mantine/theme";
import { Badge, Group, Paper, Stack, Text, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";
interface InsightsListProps {
  topics: Array<{
    target_id: string;
    groupTitle: string;
    topicTitle: string;
    vote_count: number;
    comments: string[];
  }>;
  selectedTopicId: string | null;
  onTopicSelect: (topicId: string) => void;
}

function InsightsList({ topics, selectedTopicId, onTopicSelect }: InsightsListProps) {
  const { t: tPages } = useTranslation("pages");
  return (
    <Stack gap="md">
      {topics.slice(0, 10).map((topic, idx) => {
        const isSelected = topic.target_id === selectedTopicId;
        return (
          <Paper
            key={topic.target_id}
            {...selectableLeftAccentCardProps(isSelected)}
            p={isSelected ? "sm" : "md"}
            pl={isSelected ? "sm" : "md"}
            onClick={() => onTopicSelect(topic.target_id)}
          >
            <Stack align="stretch" gap="xs">
              <Group gap="xs">
                <Badge {...surfaceRankBadgeProps()}>#{idx + 1}</Badge>
                <Text fz="xs" c="var(--text-on-selectable-muted)">
                  {topic.groupTitle}
                </Text>
              </Group>
              <Title size="h5" fw={600} c="var(--text-on-selectable)">
                {topic.topicTitle}
              </Title>
              <Text fz="sm" c="var(--text-on-selectable)">
                {tPages("canvas.insights.peopleHighlighted", {
                  count: topic.vote_count,
                })}
              </Text>
              {topic.comments.length > 0 && (
                <Text fz="xs" c="var(--text-on-selectable-muted)">
                  {tPages("canvas.insights.commentCount", { count: topic.comments.length })}
                </Text>
              )}
            </Stack>
          </Paper>
        );
      })}
    </Stack>
  );
}

export default InsightsList;
